import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatBadgeNumber(num: number | undefined) {
	if (num === undefined) {
		return "";
	}
	if (num < 100) {
		return String(num);
	}
	return "99+";
}